<template>
  <div class="editor-layout h-full flex-col">
    <OwnScrollContainer class="h-full">
      <div class="editor-layout__content">
        <slot />
      </div>
    </OwnScrollContainer>

    <div
      v-if="$slots['actions']"
      class="editor-layout__editor-actions flex-col"
    >
      <slot name="actions" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { OwnScrollContainer } from '@/ui/OwnScrollContainer'
</script>

<style lang="scss" scoped>
@use '@/styles/breakpoints';

.editor-layout {
  &__content {
    padding: 40px 16px;

    @include breakpoints.respond-to('md-and-up') {
      padding: 40px;
    }
  }

  &__editor-actions {
    padding: 16px;
    border-top: 1px solid var(--divider);
  }
}
</style>
